import styled from 'styled-components';
import { ModalBody } from 'ui/modal';
import { spacing, WebLink2 } from 'ui/theme';

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const StyledWebLink = styled(WebLink2)`
  font-size: inherit;
`;

export const InlineFlagWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: bottom;
  gap: ${spacing.half};
`;
